import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/': 'Control Panel',
  '/login': 'Login Staff',
  '/admin': 'Regia',
  '/participant': 'Partecipante',
  '/enable-device': 'Abilita dispositivo',
  '/screen': 'Maxi Schermo',
  '/vote': 'Voto Pubblico',
  '/timer': 'Timer',
  '/theme': 'Theme',
  '/fullview': 'Full View',
  '/testapi': 'Test API',
  '/selfie': 'Selfie con Andromeda',
};

export default function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    let segment = 'Italian Prompt Battle';
    if (pathname.startsWith('/screen/timer')) segment = 'Maxi · Timer';
    else if (pathname.startsWith('/screen/theme')) segment = 'Maxi · Tema';
    else if (pathname.startsWith('/screen')) segment = 'Maxi · Slot';
    else segment = TITLES[pathname] ?? segment;
    document.title = `${segment} | Italian Prompt Battle`;
  }, [pathname]);
  return null;
}
